"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RetailerOffer_1 = require("./RetailerOffer");
exports.default = RetailerOffer_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/RetailerOffer/index.js
// module id = 2390
// module chunks = 8